module.exports = __webpack_public_path__ + "static/media/upload-listing.85f9c05c.svg";